const theme = {
  colors: {
    padraoAzulEscuro: '#1351b4',
    padraoAzulClaro: '#0e717e',

    //gov.br
    azulgov: '#155DCF',
    verdegov: '#168821',
    amarelogov: '#ffa800',

    success: '#28a745',
    danger: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
    light: '#f8f9fa',
    dark: '#343a40',
    white: '#ffffff',
    black: '#000000',
    tituloColor: '#1351B4',
    cardTituloColor: '#717171',

    fundo: '#C5D4EB',
    bordaInput: '#C5D4EB',
    labelInput: '#155BCB',
    fundoInputOff: '#EBF3FF',
    hoverSidebar: '#4BABF3',

    textoAzul: '#1351B4',
    textoComum: '#333333',
    botaoLaranja: '#FFA800',
    botaoInserir: '#1351B4',
    botaoConfirmar: '#1351B4',
    botaoCinza: '#afafaf',

    preto: '#000000',
    branco: '#FFFFFF',
    vermelho: '#FF0000',
    verde: '#168821',
    jadeGreen: '#1BBC9B',
    azul: '#4BABF3',
    amarelo: '#FFFF00',
    roxo: '#AF79C4',
    rosa: '#FFC0CB',
    laranja: '#FFA500',
    laranjaTijolo: '#E77E23',
    cinza: '#808080',
    cinzaEscuro: '#717171',
    marrom: '#A52A2A',
    dourado: '#FFD700',
    prata: '#C0C0C0',
    ciano: '#00FFFF',
    magenta: '#FF00FF',
    turquesa: '#40E0D0',
    violeta: '#8A2BE2',

    card: {
      fundoAzulClaro: '#4BABF3',
      fundoVerdeClaro: '#5FD76B',
      fundoCinza: '#717171',
      textoVerde: '#168821',
      textoAzul: '#1351b4',
      borda: '#C5D4EB',
    },

    botaoAcao: {
      azul: '#1351b4',
      azulClaro: '#155DCF',
      verde: '#168821',
      amarelo: '#ffa800',
      roxo: '#AF79C4',
      laranja: '#FFA800',
      cinza: '#afafaf',
    },

    sidebar: {
      fundo: '#155DCF',
      fundoLogo: '#1868E6',
      fundoAreaUsuario: '#1351B4',
      label: '#155BCB',
    },

    barraSubAbas: {
      fundo: '#E1ECFE',
      fonte: '#1351B4',
      barra: '#4BABF3',
      icon: '#4BABF3',
    },

    filtros: {
      fundo: '#FFFFFF',
      fonte: '#1351B4',
      barra: '#4BABF3',
      icon: '#4BABF3',
      linha: '#DCDCDC',
    },

    tabela: {
      fundo: '#FFFFFF',
      fonte: '#999999',
      barra: '#4BABF3',
      icon: '#4BABF3',
      fonteTh: '#1351B4',
      fonteTd: '#717171',
      linha: '#E0E9F5',
      paginaBd: '#C5D4EB',
      fonteActive: '#4BABF3',
    },

    workspace: {
      botaoAzul: '#4BABF3',
      botaoVermelho: '#E52207',
      botaoLaranja: '#FFA800',
    },

    scrollbar: {
      track: '#f1f1f1',
      thumb: '#b5b5b5',
      thumbHover: '#afafaf',
    },
    statusTed: {
      suspenso: '#ff4646',
      cancelado: '#9c0c0c',
    },

    medsusPublic: {
      fundoBannerInfo: '#E1ECFE',
      textoBannerInfo: '#707070',
      fundoTabela: '#FFFFFF',
      textoCabecalhoTabela: '#1351B4',
      textoLinhaTabela: '#717171',
      botaoAzul: '#1868E6',
    },
  },
};

export default theme;
